import styled from 'styled-components';

export const HashListContainer = styled.div`
  position: relative;
  padding-bottom: 28px;
`;

export const HashVersion = styled.div<{ $index: number }>`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  width: 150px;
  padding-top: ${props => props.$index === 0 ? '0' : '25px'};
  color: ${props => props.$index === 0 ? '#E0E0E0' : '#9E9E9E'};
`;

export const HashLinesContainer = styled.div`
  display: flex;
  width: 55px;
  overflow: hidden;
`;

export const HashDot = styled.div`
  width: 12px;
  height: 12px;
  background-color: #525252;
  border-radius: 100%;
  position: absolute;
  top: 6px;
  left: 138px;
`;

export const HashItemContent = styled.div`
  flex: 1;
  border-bottom: 2px solid #525252;
  padding: 10px 4px;
  font-size: 14px;
`;

export const HashSeparator = styled.div<{ $index: number }>`
  width: 55px;
  border-right: ${props => props.$index === 0 ? '2px dashed #525252' : '2px solid #525252'};
  border-top: ${props => props.$index === 0 ? '2px dashed #525252' : 'none'};
  position: ${props => props.$index === 0 ? 'relative' : 'static'};
  top: ${props => props.$index === 0 ? '11px' : 'auto'};
`;

export const HashList = styled.ul<{ $index: number }>`
  display: flex;
  flex-direction: column;
  margin-top: ${props => props.$index === 0 ? '0' : '10px'};
  gap: 14px;
`;

export const HashListItemContainer = styled.div`
  display: flex;
`;

export const ListItem = styled.li`
  margin-bottom: 4px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  list-style-type: disc;
`;

export const HashText = styled.span`
  background-color: #4b4b4b;
  font-size: 12px;
  padding: 6px;
  border-radius: 2px;
`;

export const ExeHashText = styled.span`
  font-family: 'Courier New', Courier, monospace;
`;
